export default __webpack_public_path__ + "static/media/Allergies.6ad99ac9.png";